import { waitFor } from "../Helpers/pooler";
import { pushABEventToGA } from "./ABTestManager";
import * as Sentry from "@sentry/browser";

export default function () {
    waitFor(
        function () {
            return typeof window.Nobi != "undefined" && typeof window.Nobi.merchant != "undefined";
        },
        250,
        10000
    )
        .then(function () {
            if (window.Nobi.ShouldSeeNobi()) {
                pushABEventToGA("SEARCH", { slug: "NOBI" });
            } else {
                pushABEventToGA("SEARCH", { slug: "OLD" });
            }
        })
        .catch(function () {
            Sentry.captureMessage("Nobi not loaded");
        });
}
